<div class="ui-g-12 app-status-message" *ngIf="!applicationIsApproved()">
  <h4 class="section-title">
    {{ 'basic-profile.fields.concession-application-pending' | translate }}
  </h4>
</div>

<div *ngIf="applicationIsApproved()" class="ui-g data-content user-profile-content">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="page-heading text-uppercase">
      <h4 class="margin-header-align text-uppercase">{{ 'data.page-title' | translate }}</h4>
    </div>
    <hr />
  </div>

  <div class="ui-g-12 content-section">
    <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6 ui-sm-12 ui-xs-12 form-column sub-section">
      <app-concession-company-data
        #companyDataElement
        *ngIf="companyId"
        [companyId]="companyId"
        [autosave]="false"
        [updateOnConcessionValidationFormChange]="false"></app-concession-company-data>
    </div>

    <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6 ui-sm-12 ui-xs-12 form-column sub-section">
      <app-concession-technician-data
        #technicianDataElement
        [technicianId]="technicianId"
        [autosave]="false"
        [updateOnConcessionValidationFormChange]="false"></app-concession-technician-data>
    </div>

    <div class="ui-g-12 form-column sub-section">
      <app-data-concession-validation
        *ngIf="concessionValidationInitial"
        [scenario]="scenario"
        [initialValue]="concessionValidationInitial"
        [technicianName]="technicianDataForm.controls['last_name'].value"
        [dob]="technicianDataForm.controls['birthday'].value"
        (onStatusChange)="updateDataConcessionValidationStatus($event)"></app-data-concession-validation>
    </div>

    <div class="ui-g-12 form-column sub-section">
      <app-concession-files
        #concessionFiles
        *ngIf="technicianApplication"
        [dataConcessionScenario]="dataConcessionScenario"
        [technicianId]="technicianId"
        [technicianApplication]="technicianApplication"
        [autosave]="false"
        (stateChange)="concessionDocumentsStateChange($event)"></app-concession-files>
    </div>

    <div class="ui-g-12 button-rows">
      <button
        (click)="saveChanges()"
        [disabled]="isDisableSaveForm()"
        class="submit-button"
        id="password-btn-submit"
        label="{{ 'change-password.submit-button-label' | translate }}"
        pButton
        type="button"></button>

      <button
        (click)="resetForm()"
        [disabled]="
          !companyDataForm.dirty &&
          !technicianDataForm.dirty &&
          !concessionManagementDataValidationForm?.dirty &&
          !concessionDocumentsState?.dirty
        "
        class="cancel-button"
        id="password-btn-cancel"
        label="{{ 'change-password.cancel-button-label' | translate }}"
        pButton
        type="button"></button>
    </div>
  </div>
</div>

<div *ngIf="isLoading" class="loader-container">
  <div class="loader-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>
</div>
